/** @module Specification/CareAndComposition/DataSheetCareIconsMatrix */
define([
    "dojo/_base/declare",
    "csi/_base/underscore",
    "csi/store/Nodes",
    "csi/table/matrix/Path",
    "csi/xml"
], function(declare,_,Nodes,PathMatrix,xml) {

    return declare(PathMatrix, {

        /**
         * Add care symbol types to cache
         * @param {Context} ctx
         * @param {Heading} h
         * @param {Deferred[]} dfds
         */
        addDeferred: function(ctx, h, dfds) {
            var languageStore = new Nodes({
                typeNode: "EnumValue",
                requestParameters: {
                    "Qry.Limit.Path": xml.getUrlPath("centric://REFLECTION/ENUM/CareSymbolType", xml.path("Values"))
                },
                cachingStore: ctx.cache
            });

            dfds.push(languageStore.query());
        },

        /**
         * Get careIcons sorted by the SymbolType, the way it is ordered inside Language
         * @param {Context} ctx
         * @param {QueryResult} qr
         * @param {Spec} c
         * @param {Node} node
         */
        _getRowNodes: function(ctx, qr, c, node) {   
            
            var careAndCompRev = ctx.getParent();
            
            var careIcons = _.filter(ctx.cache.getNodes(careAndCompRev.CareIcons), function(node) { // filter out the null nodes
                return node;
            });
            
            var symbolTypesNotFound = [];
            
            careIcons.sort(function(icon1,icon2) {
                
                var careSymbolTypes = ctx.cache.getNodes(ctx.getContextNode().CareSymbolTypes); // get all symbol types of that language
                
                var symbolType1 = _.find(careSymbolTypes, function(symbolType) {
                    return symbolType.$Name == xml.enumGetText(icon1.SymbolType);
                });
                  
                var symbolType2 = _.find(careSymbolTypes, function(symbolType) {
                    return symbolType.$Name == xml.enumGetText(icon2.SymbolType);
                });
                
                if (!symbolType1) {
                    symbolTypesNotFound.push(icon1.SymbolType);
                } 
                
                if (!symbolType2) {
                    symbolTypesNotFound.push(icon2.SymbolType);
                } 
                
                if (!symbolType1 || !symbolType2)
                    return true;
                
                var key1 = careSymbolTypes.indexOf(symbolType1);
                var key2 = careSymbolTypes.indexOf(symbolType2);
                
                return key1 > key2;
            });
            
            if (symbolTypesNotFound.length > 0) {
                return _.filter(careIcons, function(careIcon) { // filter out the nodes with the symbol type that does not exist on the language
                    return symbolTypesNotFound.indexOf(careIcon.SymbolType) == -1;
                });
            }
            
            return careIcons;
        }

    });
});